import React from 'react'
import EmptyPlaceholder from '../../EmptyPlaceholder'
import { UprightStyle } from '../../../types'

export const styles: UprightStyle = {
  // truncate text with ellipsis after WebkitLineClamp lines
  truncate: {
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}

interface Props {
  title: number | string | JSX.Element
  titleStyle?: React.CSSProperties
  contents: React.ReactNode
}

export const OrderDetailsGridSection: React.FC<Props> = ({ title, titleStyle, contents }) => {
  return (
    <div className="order-details-grid-section">
      <p style={titleStyle}>{title}</p>
      <div style={styles.truncate}>
        <EmptyPlaceholder>{contents}</EmptyPlaceholder>
      </div>
    </div>
  )
}
